import { getFetchAudioByPath, INIT_PAGE, PAGE_SIZE } from '@/pages/Home/components/AudioList';
import { getAudioDetail, getCatalogOverview } from '@/service/audioList';
import { getFolderList } from '@/service/folder';
import { getSubscription } from '@/service/subscription';
import { useAudioDetailStore } from '@/state/audio-detail-store';
import { useAudioListStore } from '@/state/audio-list-store';
import { useCatalogOverviewStore } from '@/state/catalog-store';
import useFolderStore from '@/state/folder-store';
import { useSubscriptionStore } from '@/state/subsription-store';
import { useLocation, useParams } from 'react-router-dom';

export const useRefreshData = () => {
  // list
  const { pathname } = useLocation();
  const { updateAudioInList } = useAudioListStore();
  const { folderId } = useParams<{ folderId: string }>();

  const refreshAudioInList = async ({ id }: { id: string }) => {
    const res = await getFetchAudioByPath(pathname, {
      page: INIT_PAGE,
      pageSize: PAGE_SIZE,
      id,
      folderId: folderId ? +folderId : undefined,
    })();
    const updatedAudioInfo = res.data?.[0];
    updateAudioInList({ [id]: updatedAudioInfo });
  };
  //detail
  const { audioDetail, setAudioDetail } = useAudioDetailStore();

  const refreshSongDetail = async () => {
    if (audioDetail?.id) {
      const res = await getAudioDetail({ id: audioDetail?.id });
      if (res.data) {
        setAudioDetail(res.data);
      }
    }
  };

  // folder
  const { setFolderState } = useFolderStore();
  const refreshFolders = async () => {
    const res = await getFolderList();
    if (res.data) {
      setFolderState(res.data);
    }
  };

  // catalog overview
  const { setCatalogOverviewStore } = useCatalogOverviewStore();
  const refreshCatalogOverview = async () => {
    const res = await getCatalogOverview();
    if (res.data) {
      setCatalogOverviewStore(res.data);
    }
  };

  // subscription
  const { setSubscriptionStore } = useSubscriptionStore();
  const refreshSubscription = async () => {
    const res = await getSubscription();
    if (res?.data) {
      setSubscriptionStore(res.data);
    }
  };

  return {
    refreshAudioInList,
    refreshSongDetail,
    refreshFolders,
    refreshCatalogOverview,
    refreshSubscription,
  };
};
